import clsx from 'clsx';
import { FC, MouseEvent, ReactNode } from 'react';

import Button from 'src/components/common/button/button';

import './amplify-button.scss';

type ButtonVariantOptions = 'primary' | 'secondary' | 'blue';

type Props = {
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  onContextMenu?: (e: MouseEvent<HTMLElement>) => void;
  ariaLabel?: string;
  href?: string;
  target?: string;
  disabled?: boolean;
  variant?: ButtonVariantOptions;
};

export const AmplifyButton: FC<Props> = ({
  children,
  onClick,
  onContextMenu,
  ariaLabel,
  href,
  target,
  disabled,
  variant = 'primary',
}) => {
  const buttonClassNames = clsx('amplify-button', variant);

  if (href) {
    return (
      <Button
        className={buttonClassNames}
        onClick={onClick}
        onContextMenu={onContextMenu}
        ariaLabel={ariaLabel}
        href={href}
        target={target}
        disabled={disabled}
      >
        {children}
      </Button>
    );
  }

  return (
    <Button
      className={buttonClassNames}
      onClick={onClick}
      onContextMenu={onContextMenu}
      ariaLabel={ariaLabel}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
